import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import AdminDashboard from './AdminDashboard';
import MemberDashboard from './MemberDashboard';

export default function Dashboard() {
  const { user } = useAuth();

  if (user?.is_admin) {
    return <AdminDashboard />;
  }

  return <MemberDashboard />;
}